import OpportunityCampaignStore from './opportunity-campaign'

export default class CampaignStore extends OpportunityCampaignStore {}
